import { CAT_D, CAT_VIEWBOX, CAT_FLIP } from "./catArt";

// The Mākara Cattery brand cat — the business's ORIGINAL sitting line-art
// cat, extracted from the supplied heritage logo (lettering, circular border
// and background removed; see catArt.js). Transparent background, no text,
// and it inherits currentColor wherever it appears.
// LineCat = the cat alone. CatCrest (showText) adds the site's own arched
// MĀKARA / CATTERY lettering around it (unchanged).
export const LineCat = ({ className = "h-12 w-12" }) => (
    <svg
        viewBox={CAT_VIEWBOX}
        fill="none"
        className={className}
        aria-hidden="true"
        role="img"
        preserveAspectRatio="xMidYMid meet"
    >
        <g transform={CAT_FLIP} fill="currentColor" stroke="none">
            <path d={CAT_D} />
        </g>
    </svg>
);

export const CatCrest = ({ className = "h-12 w-12", showText = false }) => {
    if (!showText) return <LineCat className={className} />;
    return (
        <svg
            viewBox="0 0 120 140"
            fill="none"
            className={className}
            aria-hidden="true"
            role="img"
        >
            <defs>
                <path
                    id="makara-arch"
                    d="M 14 64 A 48 48 0 0 1 106 64"
                    fill="none"
                />
            </defs>
            <text
                fill="currentColor"
                fontSize="13"
                letterSpacing="4"
                fontFamily="'Cormorant Garamond', serif"
                fontWeight="600"
            >
                <textPath href="#makara-arch" startOffset="50%" textAnchor="middle">
                    MĀKARA
                </textPath>
            </text>
            {/* the original cat, scaled/centred into the crest (x 18-102, y 43-121) */}
            <g
                transform="translate(18,121.2) scale(0.01585,-0.01585)"
                fill="currentColor"
                stroke="none"
            >
                <path d={CAT_D} />
            </g>
            <text
                x="60"
                y="134"
                textAnchor="middle"
                fill="currentColor"
                fontSize="10"
                letterSpacing="5"
                fontFamily="'JetBrains Mono', monospace"
            >
                CATTERY
            </text>
        </svg>
    );
};
